module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-08.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-08.png
// module id = 1383
// module chunks = 0